import { render } from "./ModalPregunta.vue?vue&type=template&id=78e2707c"
import script from "./ModalPregunta.vue?vue&type=script&lang=js"
export * from "./ModalPregunta.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__